import { isEmpty } from 'lodash';
import { z } from 'zod';

export const stepSchema = z.object({
  title: z
    .string()
    .nullable()
    .refine(value => !isEmpty(value), { message: 'Required' }),
  expected_result: z
    .string()
    .nullable()
    .refine(value => !isEmpty(value), { message: 'Required' }),
  position_step: z.number(),
});

export type IStepSchema = z.infer<typeof stepSchema>;
